module.exports = "<section fxLayout=\"row\" fxLayoutAlign=\"center start\">\n  <section fxFlex=\"30\" fxFlex.xs=\"100\" fxFlex.sm=\"50\">\n    <h1>Welcome to Cashtracker! Please log in.</h1>\n    <app-login-form></app-login-form>\n  </section>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /srv/src/app/auth/login.component.html
// module id = ../../../../../src/app/auth/login.component.html
// module chunks = main